/**
 * Shared numeric limits aligned with backend primitive constraints.
 *
 * NOTE:
 * JavaScript numbers are IEEE-754 doubles, so very large decimals (like 18,2)
 * can lose precision at runtime. Keep these constants as source-of-truth limits
 * for validation and reuse, but avoid precision-sensitive arithmetic near bounds.
 */
export const DECIMAL_18_2_MAX = '9999999999999999.99' as const;
export const DECIMAL_18_2_MIN = '-9999999999999999.99' as const;
export const DECIMAL_18_2_MAX_AS_NUMBER = Number(DECIMAL_18_2_MAX);
export const DECIMAL_18_2_MIN_AS_NUMBER = Number(DECIMAL_18_2_MIN);

export const INT32_MAX = 2_147_483_647;
export const INT32_MIN = -2_147_483_648;
